<lib-page-container [title]="isAdding ? 'Add Staff Point Campaign' : 'Edit Staff Point Campaign'"
  [loading]="screen.isLoading()" [version]="appVersion.version" [apiVersion]="appVersion.apiVersion$ | async">
  <div lib-page-breadcrumbs>
    <lib-breadcrumbs></lib-breadcrumbs>
  </div>
  <div lib-page-actions>
    <lib-button [disabled]="screen.isLoading()"
      *appHasAnyPermission="[permissions.CAMPAIGNMANAGEMENT_WRITE, permissions.CAMPAIGN_UPDATE]" icon="save"
      (buttonClick)="onSave()" tooltip="Save">Save</lib-button>
  </div>
  <div lib-page-body>
    <div fxLayout="row" fxLayoutGap="16px" fxFlexFill>
      <app-campaign-base-edit #campaignBase [campaign]="campaign" [isStaffCampaign]="true"
        fxFlex="490px"></app-campaign-base-edit>

      <mat-card appearance="outlined" fxFlex class="mat-typography">
        <mat-card-content>
          <mat-tab-group class="tab-group">
            <mat-tab label="Strategy">
              @if (campaign) {
                <app-staff-point-strategy #campaignStrategy [advertiserId]="advertiserId" [strategy]="campaign.strategy"></app-staff-point-strategy>
              }
            </mat-tab>
            <mat-tab label="Receipt">
              @if (campaign) {
                <app-staff-point-strategy-receipt #campaignStrategyReceipt [campaignId]="campaignId" [strategy]="campaign.strategy"></app-staff-point-strategy-receipt>
              }
            </mat-tab>
            <mat-tab label="Locations">
              <app-campaign-location-filters #campaignLocationFilters [campaignId]="campaignId"></app-campaign-location-filters>
            </mat-tab>
            <mat-tab label="Json">
              <pre>{{ campaign | json }}</pre>
            </mat-tab>
            @if (campaignId) {
              <mat-tab label="Media">
                <app-campaign-media #campaignMedia [campaignId]="campaignId"></app-campaign-media>
              </mat-tab>
            }
            <mat-tab label="Banner">
              <app-campaign-banner #campaignBanner></app-campaign-banner>
            </mat-tab>
            <mat-tab>
              <ng-template mat-tab-label>
                Outbound Events
                @if (campaignOutboundEvents && campaignOutboundEvents.isValid() === false) {
                  <mat-icon class="tab-icon">warning</mat-icon>
                }
              </ng-template>
              <app-campaign-outbound-events #campaignOutboundEvents [campaignId]="campaignId"></app-campaign-outbound-events>
            </mat-tab>
          </mat-tab-group>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</lib-page-container>

<!-- <app-page [title]="isAdding ? 'Add Staff Point Campaign' : 'Edit Staff Point Campaign'">
  <app-page-actions>
    <button *appHasAnyPermission="[permissions.CAMPAIGNMANAGEMENT_WRITE, permissions.CAMPAIGN_UPDATE]" class="action-button" mat-button (click)="onSave()" matTooltip="Save"><mat-icon>save</mat-icon> Save</button>
  </app-page-actions>
  <app-page-body title=''>

    <div fxLayout="row" fxFlexFill>

      <app-campaign-base-edit #campaignBase [campaign]="campaign" [isStaffCampaign]="true" fxFlex="490px"></app-campaign-base-edit>


      <mat-card appearance="outlined" fxFlex class="mat-typography">
        <div fxLayout="column" fxLayoutAlign="start" fxFlexFill>

          <div fxLayout="row" style="margin-bottom: 30px;">
            <div fxLayout="row" fxLayoutAlign="start center" class="section-title">
              <div class="tab-item" [class.active]="viewMode == 'scheme'" (click)="viewMode = 'scheme'">Strategy</div>
              <div class="tab-item" [class.active]="viewMode == 'receipt'"   (click)="viewMode = 'receipt'">Receipt</div>
              <div class="tab-item" [class.active]="viewMode == 'locations'"  (click)="viewMode = 'locations'">Locations</div>
              <div class="tab-item" [class.active]="viewMode == 'json'"  (click)="viewMode = 'json'">Json</div>
              @if (campaignId) {
                <div class="tab-item" [class.active]="viewMode == 'media'" (click)="viewMode = 'media'">Media</div>
              }
              <div class="tab-item" [class.active]="viewMode == 'banner'"    (click)="viewMode = 'banner'">Banner</div>
            </div>
            <div fxFlex></div>
          </div>

          <div [hidden]="!(viewMode == 'scheme')">
            @if (campaign) {
              <app-staff-point-strategy #campaignStrategy [advertiserId]="advertiserId" [strategy]="campaign.strategy"></app-staff-point-strategy>
            }
          </div>

          <div [hidden]="!(viewMode == 'receipt')">
            @if (campaign) {
              <app-staff-point-strategy-receipt #campaignStrategyReceipt [campaignId]="campaignId" [strategy]="campaign.strategy"></app-staff-point-strategy-receipt>
            }
          </div>

          <div [hidden]="!(viewMode == 'json')" class="json-view">
            <pre>{{ campaign | json }}</pre>
          </div>

          <div [hidden]="!(viewMode == 'locations')">
            <app-campaign-location-filters #campaignLocationFilters [campaignId]="campaignId"></app-campaign-location-filters>
          </div>

          @if (campaignId) {
            <div [hidden]="!(viewMode == 'media')">
              <app-campaign-media #campaignMedia [campaignId]="campaignId"></app-campaign-media>
            </div>
          }

          <div [hidden]="!(viewMode == 'banner')">
            <app-campaign-banner #campaignBanner></app-campaign-banner>
          </div>

        </div>
      </mat-card>
    </div>

    <lib-loading-overlay [isLoading]="isLoading" [message]="'loading...'"></lib-loading-overlay>

  </app-page-body>
</app-page> -->